<template>
  <div
    class="bg-white fixed md:absolute top-0 md:top-full left-0 w-full md:mt-32 z-[100] shadow-xl border-t-6 border-t-primary-500 p-16 md:p-36 pb-80 overflow-auto md:overflow-visible h-screen md:h-auto print:hidden"
  >
    <Quicksearch persist-key="menu" />
  </div>
</template>
